
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { fetchList, deleteMenu, updateMenu, updateHidden } from '@/api/menu';
import { Message } from 'element-ui';

export default extend(table, {
    namespaced: true,
    state: {
        parentId: 0
    },
    actions: {
        async getList({ state, dispatch }, payload) {
            const { parentId } = state;
            await dispatch('getData', {
                caller: fetchList,
                options: {
                    parentId
                }
            });
        },
        async updateHidden({ dispatch }, payload) {
            await updateHidden(payload.id, { hidden: payload.hidden == 1 ? 0 : 1 });
            Message({
				type: "success",
				message: "修改成功!"
            });
            await dispatch('getList');
        },
        async deleteMenu({ dispatch }, payload) {
            await deleteMenu(payload);
            Message({
				type: "success",
				message: "删除成功!"
            });
            dispatch('getList');
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/ums/menu/list.js